import { BarChart3, Lightbulb, Search, Settings2 } from "lucide-react";
import WorkingBg from "../../assets/images/working-bg.png";
import ResponsiveImage from "../common/ResponsiveImage";

const processSteps = [
  {
    step: "Bước 1",
    title: "Nghiên cứu",
    description:
      "Tìm hiểu mục tiêu kinh doanh, hiện trạng hệ thống và nhu cầu thực tế để định hình giải pháp phù hợp ngay từ đầu.",
    icon: Search,
  },
  {
    step: "Bước 2",
    title: "Phân tích",
    description:
      "Đánh giá dữ liệu, xác định điểm nghẽn vận hành và xây dựng lộ trình triển khai rõ ràng theo ngân sách và tiến độ.",
    icon: Lightbulb,
  },
  {
    step: "Bước 3",
    title: "Triển khai",
    description:
      "Thực hiện giải pháp theo quy trình chuẩn, kiểm soát chất lượng kỹ thuật, bảo mật và trải nghiệm người dùng trong suốt dự án.",
    icon: Settings2,
  },
  {
    step: "Bước 4",
    title: "Kết quả",
    description:
      "Bàn giao hệ thống ổn định, hỗ trợ vận hành và đo lường hiệu quả để bảo đảm giải pháp mang lại giá trị dài hạn.",
    icon: BarChart3,
  },
];

const SectionWorkProcess: React.FC = () => {
  return (
    <section className="relative overflow-hidden bg-gradient-to-b from-white via-[#fff7f7] to-white py-16 md:py-20">
      <div className="absolute inset-0 bg-[linear-gradient(to_bottom,rgba(255,255,255,0.9),rgba(255,240,240,0.88))]" />
      <div className="relative mx-auto w-full max-w-[1280px] px-4 md:px-6 lg:px-8">
        <div className="grid items-center gap-8 rounded-[28px] border border-red-100 bg-white/90 px-4 py-6 shadow-[0_20px_60px_rgba(127,29,29,0.08)] backdrop-blur-sm md:px-6 md:py-8 lg:grid-cols-[1.02fr_1fr] lg:gap-12 lg:px-8 lg:py-10">
          <div className="relative flex min-h-[280px] items-center justify-center rounded-[24px] bg-gradient-to-br from-red-50 via-white to-red-100/60 p-4 sm:min-h-[340px] md:min-h-[440px] lg:min-h-[520px]">
            <div className="absolute inset-x-16 bottom-5 h-8 rounded-full bg-red-950/10 blur-2xl" />
            <ResponsiveImage
              src={WorkingBg}
              alt="Quy trình làm việc TrioCore Solutions"
              className="relative z-10 w-full max-w-[260px] object-contain drop-shadow-[0_20px_50px_rgba(127,29,29,0.16)] sm:max-w-[340px] md:max-w-[420px] lg:max-w-[500px]"
            />
          </div>

          <div className="relative">
            <div className="mb-8 text-left md:mb-10">
              <span className="inline-flex items-center rounded-full border border-red-500/25 bg-red-50 px-4 py-2 text-[11px] font-semibold uppercase tracking-[0.18em] text-red-700 md:text-xs">
                Mang đến sản phẩm tốt nhất
              </span>
              <h2 className="mt-5 max-w-[620px] text-left text-[24px] font-semibold leading-[1.2] text-[#3f1717] sm:text-[27px] md:text-[30px] lg:text-[33px]">
                Quy Trình Làm Việc Của TrioCore Solutions
              </h2>
            </div>

            <div className="relative space-y-5 text-left md:space-y-6">
              <div className="absolute left-[21px] top-4 hidden h-[calc(100%-36px)] w-px bg-[linear-gradient(to_bottom,rgba(220,38,38,0.85),rgba(220,38,38,0.08))] sm:block" />

              {processSteps.map(({ step, title, description, icon: Icon }) => (
                <div key={step} className="group relative pl-14 text-left sm:pl-16">
                  <div className="absolute left-0 top-1 flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-red-500 to-red-700 text-white shadow-[0_10px_24px_rgba(220,38,38,0.24)] ring-4 ring-white sm:h-11 sm:w-11 md:h-12 md:w-12">
                    <Icon size={20} strokeWidth={2.2} />
                  </div>

                  <div className="pt-0.5 text-left">
                    <p className="text-[13px] font-semibold tracking-wide text-red-600 sm:text-sm">
                      {step}
                    </p>
                    <h3 className="mt-1 text-left text-[18px] font-semibold leading-tight text-[#2f1a1a] sm:text-[19px] md:text-[20px]">
                      {title}
                    </h3>
                    <p className="mt-2 max-w-[620px] text-left text-[14px] leading-6 text-gray-600 md:text-[15px] md:leading-7">
                      {description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionWorkProcess;
